import React from 'react'
import ReactDOM from 'react-dom'
import AppDocs from 'app/AppDocs.jsx'

import 'app/assets/scss/index.scss'

const pkgPath = '/home/lapis/repos/gh/farrapa'

const pkgJson = JSON.parse(`
  {
  "name": "farrapa",
  "version": "2.3.0",
  "description": "diverse utils used by afialapis",
  "author": "Donato Lorenzo <donato@afialapis.com>",
  "contributors": [
    "Donato Lorenzo <donato@afialapis.com>"
  ],
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/afialapis/farrapa.git"
  },
  "bugs": {
    "url": "https://github.com/afialapis/farrapa/issues"
  },
  "homepage": "https://www.afialapis.com/os/farrapa",
  "files": [
    "package.json",
    "src",
    "lib",
    "dist",
    "LICENSE",
    "README.md"
  ],
  "type": "module",
  "main": "./lib/index.cjs",
  "exports": {
    ".": {
      "import": "./src/index.mjs",
      "require": "./lib/index.cjs",
      "default": "./lib/index.cjs"
    },
    "./colors": {
      "import": "./src/colors/index.mjs",
      "require": "./lib/colors/index.cjs",
      "default": "./lib/colors/index.cjs"
    },
    "./numbers": {
      "import": "./src/numbers/index.mjs",
      "require": "./lib/numbers/index.cjs",
      "default": "./lib/numbers/index.cjs"
    },
    "./commons": {
      "import": "./src/commons/index.mjs",
      "require": "./lib/commons/index.cjs",
      "default": "./lib/commons/index.cjs"
    },
    "./checkers": {
      "import": "./src/checkers/index.mjs",
      "require": "./lib/checkers/index.cjs",
      "default": "./lib/checkers/index.cjs"
    },
    "./collections": {
      "import": "./src/collections/index.mjs",
      "require": "./lib/collections/index.cjs",
      "default": "./lib/collections/index.cjs"
    },
    "./encoding": {
      "import": "./src/encoding/index.mjs",
      "require": "./lib/encoding/index.cjs",
      "default": "./lib/encoding/index.cjs"
    },
    "./iter": {
      "import": "./src/iter/index.mjs",
      "require": "./lib/iter/index.cjs",
      "default": "./lib/iter/index.cjs"
    },
    "./memoize": {
      "import": "./src/memoize/index.mjs",
      "require": "./lib/memoize/index.cjs",
      "default": "./lib/memoize/index.cjs"
    },
    "./objects": {
      "import": "./src/objects/index.mjs",
      "require": "./lib/objects/index.cjs",
      "default": "./lib/objects/index.cjs"
    },
    "./pretty-console": {
      "import": "./src/pretty-console/index.mjs",
      "require": "./lib/pretty-console/index.cjs",
      "default": "./lib/pretty-console/index.cjs"
    },
    "./promises": {
      "import": "./src/promises/index.mjs",
      "require": "./lib/promises/index.cjs",
      "default": "./lib/promises/index.cjs"
    },
    "./strings": {
      "import": "./src/strings/index.mjs",
      "require": "./lib/strings/index.cjs",
      "default": "./lib/strings/index.cjs"
    },
    "./url": {
      "import": "./src/url/index.mjs",
      "require": "./lib/url/index.cjs",
      "default": "./lib/url/index.cjs"
    }
  },
  "cjs": "dist/farrapa.cjs",
  "module": "dist/farrapa.mjs",
  "browser": "dist/farrapa.umd.js",
  "scripts": {
    "lint": "npx xeira lint --folder=./src",
    "clean-lib": "rm -fr ./lib && mkdir lib",
    "lib": "npx xeira transpile --source_index=./src/index.mjs --minifier=null",
    "clean-dist": "rm -fr ./dist && mkdir dist",
    "dist": "npx xeira bundle --source_index=./src/index.mjs",
    "clean": "npm run clean-lib && npm run clean-dist",
    "reset": "npm run clean && rm -fr package-lock.json node_modules && npm i",
    "site": "npx xeira site",
    "prepare": "npm run clean && npm run lint && npm run lib && npm run dist && npm run site"
  },
  "keywords": [
    "js",
    "util"
  ],
  "devDependencies": {
    "xeira": "^1.1.0"
  },
  "eslintConfig": {
    "extends": [
      "./node_modules/xeira/configs/eslint.cjs"
    ]
  },
  "dependencies": {
    "tinguir": "^0.0.7"
  }
}
`)

const arreConfig = JSON.parse(`
{
  "theme": "default",
  "company": "Afialapis",
  "company_url": "https://www.afialapis.com",
  "url": "https://www.afialapis.com/os/farrapa",
  "doc_versions": [],
  "md": {
    "md_keep_summary_content": false,
    "md_strip_details_tag": true
  },
  "demo_entry": "",
  "has_demo": false,
  "logo": {
    "ok": true,
    "src": "./logo/farrapa.png",
    "dest": "logo.png"
  },
  "favicon": {
    "main": {
      "ok": true,
      "src": "./logo/favicon/farrapa.png",
      "dest": "favicon.png"
    },
    "ico": {
      "ok": true,
      "src": "./logo/favicon/farrapa.ico",
      "dest": "favicon.ico"
    },
    "apple": {
      "ok": true,
      "src": "./logo/favicon/farrapa_apple.png",
      "dest": "favicon_apple.png"
    }
  }
}
`)

const md_2_3_0 = decodeURIComponent(escape(window.atob(`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`)));


const readmes = {
"2.3.0": md_2_3_0,
}



ReactDOM.render(
  <AppDocs 
    pkgPath = {pkgPath}
    pkgJson = {pkgJson}
    arreConfig = {arreConfig}
    readmes = {readmes}      
  />,
  document.getElementById('arredemo-app'))

/*

// React 18

ReactDOM.createRoot(document.getElementById("arredemo-app")).render(
  <React.StrictMode>
    <AppDocs 
      pkgPath = {pkgPath}
      pkgJson = {pkgJson}
      arreConfig = {arreConfig}
      readmes = {readmes}      
    />
  </React.StrictMode>
);
*/

